import type { AcademyContent } from "@/components/ui/arbi-academy-modal";

export const JOBS_ACADEMY_CONTENT: AcademyContent = {
  type: "jobs",
  typeLabel: "Jobs",
  title: "Jobs & Stages Fundamentals",
  description:
    "Learn how to create job requisitions, configure hiring stages, assign team members, and track candidates through your pipeline. This video covers everything from setting up your first job to managing multi-stage workflows across your organization.",
  duration: "3 mins",
  videoUrl: "https://www.youtube.com/watch?v=setu9Ir1miY",
  thumbnailUrl: "/assets/academy/jobs-thumbnail.png",
  accentColor: "#fd90a8",
  typeColor: "#8fb0ef",
  docsUrl: "https://docs.neuroscale.ai/core/job-requisitions",
};
